<!--
 * @Author: 1739017283@qq.com
 * @Date: 2025-04-07 15:09:12
 * @LastEditors: 1739017283@qq.com
 * @LastEditTime: 2025-04-08 10:33:08
 * @FilePath: \knowledge-graph\src\views\Login\forget.vue
 * @Description: 忘记密码
-->
<template>
  <div class="com-login-container">
    <div class="com-login-container-left">
      <img src="@/assets/login/login-bg.png" alt="">
    </div>
    <div class="com-login-container-right">
      <h2>找回密码</h2>
      <div class="com-login-container-right-form-item">
        <img src="@/assets/login/phone.png" alt="">
        <input type="text" placeholder="请输入注册手机号" />
      </div>
      <div class="com-login-container-right-form-code">
        <div class="com-login-container-right-form-item code-input">
          <img src="@/assets/login/password.png" alt="">
          <input type="text" placeholder="请输入验证码" />
        </div>
        <div class="com-login-container-right-form-code-btn">获取验证码</div>
      </div>
      <div class="com-login-container-right-form-item">
        <img src="@/assets/login/password.png" alt="">
        <input type="text" placeholder="请输入新密码" />
      </div>
      <div class="com-login-container-right-form-item">
        <img src="@/assets/login/password.png" alt="">
        <input type="text" placeholder="请再次输入新密码" />
      </div>
      <div class="com-login-container-right-form-btn">确定</div>
      <div class="com-login-container-right-form-back" @click.stop="$emit('jump', 'login')">返回登录</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ForgetIndex'
}
</script>
